import React, { Component } from "react";
import {
  withStyles,
  MenuItem,
  FormControl,
  Select,
  OutlinedInput,
  InputLabel,
  Card,
  CardHeader,
  Avatar,
  CardContent,
  Grid,
  Typography,
  Divider,
  CardActions,
  Button,
  Paper,
} from "@material-ui/core";
import PreviousExamination from "./PreviousExamination";
import BestOfThree from "./BestOfThree";
import SubjectsCombo from "./SubjectsCombo";
import { blue, lightGreen, orange, green } from "@material-ui/core/colors";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import AlertDiv from "./AlertDiv";
import { GetData } from "../../../api/service";
import Grade from "@material-ui/icons/Grade";
import Sel from "react-select";
import MultiSubject from "./MultiSubject";
import LastMarks from "./LastMarks";
import { Modal } from 'antd';

const styles = (theme) => ({
  buttonSubmit: {
    color: "white",
    backgroundColor: blue[400],
    "&:hover": {
      color: blue[400],
      backgroundColor: "white",
      border: `solid thin ${blue[400]}`,
    },
  },
  cardActions: {
    justifyContent: "flex-end",
  },
  redStrip: {
    width: "100%",
    height: 8,
    backgroundColor: "#1715DA",
  },
});

class EducationalFormBSC extends Component {
  state = {
    course: "BSC",
    stream: "",
    course_type: "HONOURS",
    semester: 1,
    email: this.props.user.email,
    exam_passed: [],
    best_subjects: [],
    last_marks: [],
    total_marks: "",
    marks_obtained: "",
    percentage: "",

    errors: [],
    major_1: null,
    major_1_m_1: null,
    major_1_m_2: null,
    major_1_m_3: null,
    major_1_m_4: null,
    major_1_m_5: null,

    generic_1_1: null,
    generic_1_m_1: null,
    generic_1_m_2: null,
    generic_1_m_3: null,
    generic_1_m_4: null,
    generic_1_m_5: null,

    generic_1_2: null,
    generic_2_m_1: null,
    generic_2_m_2: null,
    generic_2_m_3: null,
    generic_2_m_4: null,
    generic_2_m_5: null,

    mil: null,
    aec_list: [],
    vac: null,
    vac_list: [],

    major_list: [],
    major_list_1: [],
    major_list_2: [],
    major_list_3: [],
    major_list_4: [],
    major_list_5: [],
    f_major_list_1: [],
    f_major_list_2: [],
    f_major_list_3: [],
    f_major_list_4: [],
    f_major_list_5: [],
    f_major_list: [],

    mdc_1: null,
    mdc_list_1: [],
    mdc_list_2: [],
    mdc_list_3: [],
    mdc_1_m_1: null,
    mdc_1_m_2: null,
    mdc_1_m_3: null,


    isLoaded: false,
    isDisabled: false,

    has_gap: "",
    gap_admission: "",
    gap_course: "",
    gap_institute: "",
    gap_reason: "",
    gap_roll_no: "",
    unique_id: "",
    subjects_choosen: [],
    subject_combination: []
  };

  componentDidMount() {
    let data = this.props.data;

    if (Array.isArray(data) && data.length > 0) {
      this.setState(
        {
          ...data[0],
          course_type: "HONOURS",
        },
        () => {

          let lm = [];

          if (
            Array.isArray(data[0].last_marks) &&
            data[0].last_marks.length == 0
          ) {

            lm = [
              { subject: "English", total_marks: "100", marks_secured: "", readOnly: true },
              { subject: "", total_marks: "100", marks_secured: "", readOnly: false },
              { subject: "", total_marks: "100", marks_secured: "", readOnly: false },
              { subject: "", total_marks: "100", marks_secured: "", readOnly: false },
              { subject: "", total_marks: "100", marks_secured: "", readOnly: false },
            ];

          }

          this.setState(
            {
              last_marks: lm,

            },
            () => {
              this.__getData();

            }
          );

        }
      );
    }
  }
  __getData = () => {


    GetData(`/${this.state.course}/getadmissionsubject`).then((resp) => {
      //console.log("EducationalForm -> __getData -> resp", resp);
      //console.log(resp)
      let major_list = [], major_list_1 = [], major_list_2 = [], major_list_3 = [], major_list_5 = [], major_list_4 = [], mdc_list_1 = [], mdc_list_2 = [], mdc_list_3 = [], aec_list = [], vac_list = [];

      major_list_1 = resp?.filter((el) => el.sub_code == 'PHY-C-FYUGP' || el.sub_code == 'CHM-C-FYUGP' || el.sub_code == 'MATH-C-FYUGP' || el.sub_code == 'STS-C-FYUGP')
      major_list_2 = resp?.filter((el) => el.sub_code == 'ANTH-C-FYUGP' || el.sub_code == 'BOT-C-FYUGP' || el.sub_code == 'ZOO-C-FYUGP')
      major_list_3 = resp?.filter((el) => el.sub_code == 'GGY-C-FYUGP' || el.sub_code == 'GEO-C-FYUGP')
      major_list_4 = resp?.filter((el) => el.sub_code == 'CS-C-FYUGP')
      major_list_5 = resp?.filter((el) => el.sub_code == 'ECO-C-FYUGP')
      major_list = [...major_list_1, ...major_list_2, ...major_list_3, ...major_list_4]

      // mdc_list_1 = resp?.filter((el) => el.sub_code == 'PHYNAS-M-FYUGP' || el.sub_code == 'CHM-M-FYUGP' || el.sub_code == 'BIO-M-FYUGP' || el.sub_code == 'ES-M-FYUGP')
      mdc_list_1 = resp?.filter((el) => el.sub_code === "MDH-MDC-FYUGP" || el.sub_code === "MDC-MDC-FYUGP")


      mdc_list_2 = resp?.filter((el) => el.sub_code == 'BMS-M-FYUGP')
      mdc_list_3 = resp?.filter((el) => el.sub_code == 'CS-M-FYUGP')

      let mil = resp?.find((el) => el.sub_code === "ENG-AEC") || null; // AEC
      aec_list = resp?.filter((el) => el.sub_type === "AEC" && el.is_FYUGP == 1);
      let vac = resp?.find((el) => el.sub_code === "ENV-AE") || null; // VAC
      vac_list = resp?.filter((el) => el.sub_type === "VAC"); // VAC


      let subjects_choosen = this.state.subjects_choosen;
      let major_1 = null, major_1_m_1 = null, major_1_m_2 = null, major_1_m_3 = null, major_1_m_4 = null, major_1_m_5 = null;
      let generic_1_1 = null, generic_1_m_1 = null, generic_1_m_2 = null, generic_1_m_3 = null, generic_1_m_4 = null, generic_1_m_5 = null;
      let generic_1_2 = null, generic_2_m_1 = null, generic_2_m_2 = null, generic_2_m_3 = null, generic_2_m_4 = null, generic_2_m_5 = null;
      let mdc_1 = null, mdc_1_m_1 = null, mdc_1_m_2 = null, mdc_1_m_3 = null;

      if (
        Array.isArray(subjects_choosen) &&
        subjects_choosen.length > 0
      ) {

        major_1 = subjects_choosen.find((el) => el.type === 'major_1')?.subject || null;
        if (major_1 !== null && major_1 !== undefined) {
          major_1_m_1 = major_list_1?.find((el) => el.value === major_1?.value) || null;
          major_1_m_2 = major_list_2?.find((el) => el.value === major_1?.value) || null;
          major_1_m_3 = major_list_3?.find((el) => el.value === major_1?.value) || null;
          major_1_m_4 = major_list_4?.find((el) => el.value === major_1?.value) || null;
          major_1_m_5 = major_list_5?.find((el) => el.value === major_1?.value) || null;
        }

        generic_1_1 = subjects_choosen.find((el) => el.type === 'generic_1_1')?.subject || null;

        if (generic_1_1 !== null && generic_1_1 !== undefined) {
          generic_1_m_1 = major_list_1?.find((el) => el.value === generic_1_1?.value) || null;
          generic_1_m_2 = major_list_2?.find((el) => el.value === generic_1_1?.value) || null;
          generic_1_m_3 = major_list_3?.find((el) => el.value === generic_1_1?.value) || null;
          generic_1_m_4 = major_list_4?.find((el) => el.value === generic_1_1?.value) || null;
          generic_1_m_5 = major_list_5?.find((el) => el.value === generic_1_1?.value) || null;
        }

        generic_1_2 = subjects_choosen.find((el) => el.type === 'generic_1_2')?.subject || null;
        if (generic_1_2 !== null && generic_1_2 !== undefined) {
          generic_2_m_1 = major_list_1?.find((el) => el.value === generic_1_2?.value) || null;
          generic_2_m_2 = major_list_2?.find((el) => el.value === generic_1_2?.value) || null;
          generic_2_m_3 = major_list_3?.find((el) => el.value === generic_1_2?.value) || null;
          generic_2_m_4 = major_list_4?.find((el) => el.value === generic_1_2?.value) || null;
          generic_2_m_5 = major_list_5?.find((el) => el.value === generic_1_2?.value) || null;
        }

        mdc_1 = subjects_choosen.find((el) => el.type === 'mdc_1')?.subject || null;
        if (mdc_1 !== null && mdc_1 !== undefined) {
          mdc_1_m_1 = mdc_list_1?.find((el) => el.value === mdc_1?.value) || null;
          mdc_1_m_2 = mdc_list_2?.find((el) => el.value === mdc_1?.value) || null;
          mdc_1_m_3 = mdc_list_3?.find((el) => el.value === mdc_1?.value) || null;
        }

      }

      this.setState(
        {
          major_list_1,
          major_list_2,
          major_list_3,
          major_list_4,
          major_list_5,
          f_major_list_1: major_list_1,
          f_major_list_2: major_list_2,
          f_major_list_3: major_list_3,
          f_major_list_4: major_list_4,
          f_major_list_5: major_list_5,
          mdc_list_1,
          mdc_list_2,
          mdc_list_3,
          aec_list,
          major_list,
          f_major_list: major_list,
          major_1,
          major_1_m_1,
          major_1_m_2,
          major_1_m_3,
          major_1_m_4,
          major_1_m_5,
          generic_1_1,
          generic_1_m_1,
          generic_1_m_2,
          generic_1_m_3,
          generic_1_m_4,
          generic_1_m_5,
          generic_1_2,
          generic_2_m_1,
          generic_2_m_2,
          generic_2_m_3,
          generic_2_m_4,
          generic_2_m_5,
          mdc_1,
          mdc_1_m_1,
          mdc_1_m_2,
          mdc_1_m_3,
          mil,
          aec_list,
          vac_list,
          vac,
          isLoaded: true,
        },
        () => {
          //console.log(this.state)
          //this.setSubjectFilter();

        }
      );



    });

  };


  onNewChange = (name, value) => {
    console.log("🚀 ~ file: EducationalFormBSC.js:294 ~ EducationalFormBSC ~ name:", name)
    this.setState({
      [name]: value,
    });
  };


  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });

  };

  setSubjectFilter = () => {

    let f_major_list = [...this.state.major_list];
    let f_major_list_1 = [...this.state.major_list_1];
    let f_major_list_2 = [...this.state.major_list_2];
    let f_major_list_3 = [...this.state.major_list_3];
    let f_major_list_4 = [...this.state.major_list_4];
    let f_major_list_5 = [...this.state.major_list_5];

    let major_1 = this.state.major_1;
    let major_1_m_1 = this.state.major_1_m_1;
    let major_1_m_2 = this.state.major_1_m_2;
    let major_1_m_3 = this.state.major_1_m_3;
    let major_1_m_4 = this.state.major_1_m_4;
    let major_1_m_5 = this.state.major_1_m_5;

    let generic_1_1 = this.state.generic_1_1;
    let generic_1_m_1 = this.state.generic_1_m_1;
    let generic_1_m_2 = this.state.generic_1_m_2;
    let generic_1_m_3 = this.state.generic_1_m_3;
    let generic_1_m_4 = this.state.generic_1_m_4;
    let generic_1_m_5 = this.state.generic_1_m_5;

    let generic_1_2 = this.state.generic_1_2;
    let generic_2_m_1 = this.state.generic_2_m_1;
    let generic_2_m_2 = this.state.generic_2_m_2;
    let generic_2_m_3 = this.state.generic_2_m_3;
    let generic_2_m_4 = this.state.generic_2_m_4;
    let generic_2_m_5 = this.state.generic_2_m_5;


    let chemistry = this.state.major_list_1.find((el) => el.value == 'CHM-C-FYUGP');



    if (major_1_m_1 != null && major_1_m_1 != undefined) {
      f_major_list_1 = f_major_list_1?.filter((el) => el.value != major_1_m_1.value);

    }
    else if (major_1_m_2 != null && major_1_m_2 != undefined) {
      f_major_list_2 = f_major_list_2?.filter((el) => el.value != major_1_m_2.value);

      if (major_1_m_2.value == 'BOT-C-FYUGP') {
        generic_1_m_1 = chemistry;
      }
    }
    else if (major_1_m_3 != null && major_1_m_3 != undefined) {
      f_major_list_3 = f_major_list_3?.filter((el) => el.value != major_1_m_3.value);

      //exception

      if (major_1_m_3?.value == 'GGY-C-FYUGP') {
        f_major_list_3 = f_major_list_3.filter((el) => el.value != 'GEO-C-FYUGP')
      }


      else if (major_1_m_3?.value == 'GEO-C-FYUGP') {
        f_major_list_3 = f_major_list_3.filter((el) => el.value != 'GGY-C-FYUGP')
      }

    }
    else if (major_1_m_4 != null && major_1_m_4 != undefined) {
      f_major_list_4 = f_major_list_4?.filter((el) => el.value != major_1_m_4.value);

    }

    if (generic_1_m_1 != null && generic_1_m_1 != undefined) {
      f_major_list_1 = f_major_list_1?.filter((el) => el.value != generic_1_m_1.value);

    }
    else if (generic_1_m_2 != null && generic_1_m_2 != undefined) {
      f_major_list_2 = f_major_list_2?.filter((el) => el.value != generic_1_m_2.value);

      if (generic_1_m_2.value == 'BOT-C-FYUGP') {
        generic_2_m_1 = chemistry;
      }

    }
    else if (generic_1_m_3 != null && generic_1_m_3 != undefined) {
      f_major_list_3 = f_major_list_3?.filter((el) => el.value != generic_1_m_3.value);

      //exception

      if (generic_1_m_3?.value == 'GGY-C-FYUGP') {
        f_major_list_3 = f_major_list_3.filter((el) => el.value != 'GEO-C-FYUGP')
      }


      else if (generic_1_m_3?.value == 'GEO-C-FYUGP') {
        f_major_list_3 = f_major_list_3.filter((el) => el.value != 'GGY-C-FYUGP')
      }

    }
    else if (generic_1_m_4 != null && generic_1_m_4 != undefined) {
      f_major_list_4 = f_major_list_4?.filter((el) => el.value != generic_1_m_4.value);

    }


    if (generic_2_m_1 != null && generic_2_m_1 != undefined) {
      f_major_list_1 = f_major_list_1?.filter((el) => el.value != generic_2_m_1.value);

    }
    else if (generic_2_m_2 != null && generic_2_m_2 != undefined) {
      f_major_list_2 = f_major_list_2?.filter((el) => el.value != generic_2_m_2.value);

      if (generic_2_m_2.value == 'BOT-C-FYUGP') {
        generic_1_m_1 = chemistry;
      }

    }
    else if (generic_2_m_3 != null && generic_2_m_3 != undefined) {
      f_major_list_3 = f_major_list_3?.filter((el) => el.value != generic_2_m_3.value);

      //exception

      if (generic_2_m_3?.value == 'GGY-C-FYUGP') {
        f_major_list_3 = f_major_list_3.filter((el) => el.value != 'GEO-C-FYUGP')
      }


      else if (generic_2_m_3?.value == 'GEO-C-FYUGP') {
        f_major_list_3 = f_major_list_3.filter((el) => el.value != 'GGY-C-FYUGP')
      }

    }
    else if (generic_2_m_4 != null && generic_2_m_4 != undefined) {
      f_major_list_4 = f_major_list_4?.filter((el) => el.value != generic_2_m_4.value);

    }



    if (major_1?.value == generic_1_1?.value || major_1?.value == generic_1_2?.value || generic_1_1?.value == generic_1_2?.value) {
      major_1 = null;
      generic_1_1 = null;
      generic_1_2 = null;
    }



    this.setState({
      f_major_list,
      f_major_list_1,
      f_major_list_2,
      f_major_list_3,
      f_major_list_4,
      major_1,
      generic_1_1,
      generic_1_2,
      generic_1_m_1,
      generic_1_m_2,
      generic_1_m_3,
      generic_1_m_4,
      generic_2_m_1,
      generic_2_m_2,
      generic_2_m_3,
      generic_2_m_4
    }, () => {
      //console.log(this.state)
    });


  };

  onSubChange = (name, e) => {

    //Major
    if (name == 'major_1_m_1') {
      this.setState(
        {
          [name]: e,
          major_1_m_2: null,
          major_1_m_3: null,
          major_1_m_4: null,
          major_1_m_5: null,
          major_1: null
        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'major_1_m_2') {
      this.setState(
        {
          [name]: e,
          major_1_m_1: null,
          major_1_m_3: null,
          major_1_m_4: null,
          major_1_m_5: null,
          major_1: null

        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'major_1_m_3') {
      this.setState(
        {
          [name]: e,
          major_1_m_1: null,
          major_1_m_2: null,
          major_1_m_4: null,
          major_1_m_5: null,
          major_1: null

        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'major_1_m_4') {
      this.setState(
        {
          [name]: e,
          major_1_m_1: null,
          major_1_m_2: null,
          major_1_m_3: null,
          major_1_m_5: null,
          major_1: null
        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'major_1_m_5') {
      this.setState(
        {
          [name]: e,
          major_1_m_1: null,
          major_1_m_2: null,
          major_1_m_3: null,
          major_1_m_4: null,
          major_1: null
        },
        () => {

          //this.setSubjectFilter();
        })
    }

    //minor I
    else if (name == 'generic_1_m_1') {
      this.setState(
        {
          [name]: e,
          generic_1_m_2: null,
          generic_1_m_3: null,
          generic_1_m_4: null,
          generic_1_m_5: null,
          generic_1_1: null
        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'generic_1_m_2') {
      this.setState(
        {
          [name]: e,
          generic_1_m_1: null,
          generic_1_m_3: null,
          generic_1_m_4: null,
          generic_1_m_5: null,
          generic_1_1: null

        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'generic_1_m_3') {
      this.setState(
        {
          [name]: e,
          generic_1_m_1: null,
          generic_1_m_2: null,
          generic_1_m_4: null,
          generic_1_m_5: null,
          generic_1_1: null

        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'generic_1_m_4') {
      this.setState(
        {
          [name]: e,
          generic_1_m_1: null,
          generic_1_m_2: null,
          generic_1_m_3: null,
          generic_1_m_5: null,
          generic_1_1: null

        },
        () => {

         // this.setSubjectFilter();
        })
    }
    else if (name == 'generic_1_m_5') {
      this.setState(
        {
          [name]: e,
          generic_1_m_1: null,
          generic_1_m_2: null,
          generic_1_m_3: null,
          generic_1_m_4: null,
          generic_1_1: null

        },
        () => {

          //this.setSubjectFilter();
        })
    }

    //minor II
    else if (name == 'generic_2_m_1') {
      this.setState(
        {
          [name]: e,
          generic_2_m_2: null,
          generic_2_m_3: null,
          generic_2_m_4: null,
          generic_2_m_5: null,
          generic_1_2: null,
        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'generic_2_m_2') {
      this.setState(
        {
          [name]: e,
          generic_2_m_1: null,
          generic_2_m_3: null,
          generic_2_m_4: null,
          generic_2_m_5: null,
          generic_1_2: null,

        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'generic_2_m_3') {
      this.setState(
        {
          [name]: e,
          generic_2_m_1: null,
          generic_2_m_2: null,
          generic_2_m_4: null,
          generic_2_m_5: null,
          generic_1_2: null,

        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'generic_2_m_4') {
      this.setState(
        {
          [name]: e,
          generic_2_m_1: null,
          generic_2_m_2: null,
          generic_2_m_3: null,
          generic_2_m_5: null,
          generic_1_2: null,

        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'generic_2_m_5') {
      this.setState(
        {
          [name]: e,
          generic_2_m_1: null,
          generic_2_m_2: null,
          generic_2_m_3: null,
          generic_2_m_4: null,
          generic_1_2: null,

        },
        () => {

          //this.setSubjectFilter();
        })
    }

    //MDC
    else if (name == 'mdc_1_m_1') {
      this.setState(
        {
          [name]: e,
          mdc_1_m_2: null,
          mdc_1_m_3: null,
          mdc_1: null
        },
        () => {

          //this.setSubjectFilter();
        })
    }
    else if (name == 'mdc_1_m_2') {
      this.setState(
        {
          [name]: e,
          mdc_1_m_1: null,
          mdc_1_m_3: null,
          mdc_1: null
        },
        () => {

         // this.setSubjectFilter();
        })
    }
    else if (name == 'mdc_1_m_3') {
      this.setState(
        {
          [name]: e,
          mdc_1_m_1: null,
          mdc_1_m_2: null,
          mdc_1: null
        },
        () => {

         // this.setSubjectFilter();
        })
    }

    //others
    else {
      this.setState(
        {
          [name]: e,

        },
        () => {

          //this.setSubjectFilter();
        })
    }


  };

  handleValidation = () => {
    let {
      unique_id,
      major_1,
      major_1_m_1,
      major_1_m_2,
      major_1_m_3,
      major_1_m_4,
      major_1_m_5,
      generic_1_1,
      generic_1_m_1,
      generic_1_m_2,
      generic_1_m_3,
      generic_1_m_4,
      generic_1_m_5,
      generic_1_2,
      generic_2_m_1,
      generic_2_m_2,
      generic_2_m_3,
      generic_2_m_4,
      generic_2_m_5,
      mdc_1,
      mdc_1_m_1,
      mdc_1_m_2,
      mdc_1_m_3,
      mil,
      vac,
      course,
      exam_passed,
      best_subjects,
      last_marks,
      has_gap,
      gap_admission,
      gap_course,
      gap_institute,
      gap_reason,
      gap_roll_no,
      errors,
    } = this.state;
    let isValid = true;
    let subjects_choosen = [];

    // if (unique_id === null || unique_id === '') {
    //   isValid = false;
    //   errors["unique_id"] = "Please fill up Unique Id";
    // } else {
    //   errors["unique_id"] = "";
    // }

    if (major_1_m_1 !== null && major_1_m_1 !== undefined) {
      major_1 = major_1_m_1;
    }
    else if (major_1_m_2 !== null && major_1_m_2 !== undefined) {
      major_1 = major_1_m_2;
    }
    else if (major_1_m_3 !== null && major_1_m_3 !== undefined) {
      major_1 = major_1_m_3;
    }
    else if (major_1_m_4 !== null && major_1_m_4 !== undefined) {
      major_1 = major_1_m_4;
    }
    else if (major_1_m_5 !== null && major_1_m_5 !== undefined) {
      major_1 = major_1_m_5;
    }

    if (major_1 !== null && major_1 !== undefined) {
      if (Object.entries(major_1).length === 0) {
        isValid = false;

        errors["major_1"] = "Please Select Core Course MAJOR";
      } else {
        errors["major_1"] = "";

        subjects_choosen.push({
          type: 'major_1',
          subject: major_1
        });
      }
    } else {
      isValid = false;
      errors["major_1"] = "Please Select Core Course MAJOR";
    }

    if (generic_1_m_1 !== null && generic_1_m_1 !== undefined) {
      generic_1_1 = generic_1_m_1;
    }
    else if (generic_1_m_2 !== null && generic_1_m_2 !== undefined) {
      generic_1_1 = generic_1_m_2;
    }
    else if (generic_1_m_3 !== null && generic_1_m_3 !== undefined) {
      generic_1_1 = generic_1_m_3;
    }
    else if (generic_1_m_4 !== null && generic_1_m_4 !== undefined) {
      generic_1_1 = generic_1_m_4;
    }
    else if (generic_1_m_5 !== null && generic_1_m_5 !== undefined) {
      generic_1_1 = generic_1_m_5;
    }
    if (generic_1_1 !== null && generic_1_1 !== undefined) {
      if (Object.keys(generic_1_1).length === 0) {
        isValid = false;
        errors['generic_1_1'] = 'Please Select Core Coure MINOR I'
      } else {
        errors['generic_1_1'] = '';

        subjects_choosen.push({
          type: 'generic_1_1',
          subject: generic_1_1
        });
      }
    } else {
      isValid = false;
      errors['generic_1_1'] = 'Please Select Core Coure MINOR I'
    }

    if (generic_2_m_1 !== null && generic_1_m_1 !== undefined) {
      generic_1_2 = generic_2_m_1
    }
    else if (generic_2_m_2 !== null && generic_2_m_2 !== undefined) {
      generic_1_2 = generic_2_m_2
    }
    else if (generic_2_m_3 !== null && generic_2_m_3 !== undefined) {
      generic_1_2 = generic_2_m_3
    }
    else if (generic_2_m_4 !== null && generic_2_m_4 !== undefined) {
      generic_1_2 = generic_2_m_4
    }
    else if (generic_2_m_5 !== null && generic_2_m_5 !== undefined) {
      generic_1_2 = generic_2_m_5
    }

    if (generic_1_2 !== null && generic_1_2 !== undefined) {
      if (Object.keys(generic_1_2).length === 0) {
        isValid = false;
        errors['generic_1_2'] = 'Please Select Core Course MINOR II'
      } else {
        errors['generic_1_2'] = '';

        subjects_choosen.push({
          type: 'generic_1_2',
          subject: generic_1_2
        });
      }
    } else {
      isValid = false;
      errors['generic_1_2'] = 'Please Select Core Course MINOR II'

    }


    if (mdc_1_m_1 !== null && mdc_1_m_1 !== undefined) {
      mdc_1 = mdc_1_m_1
    }
    else if (mdc_1_m_2 !== null && mdc_1_m_2 !== undefined) {
      mdc_1 = mdc_1_m_2
    }
    else if (mdc_1_m_3 !== null && mdc_1_m_3 !== undefined) {
      mdc_1 = mdc_1_m_3
    }


    if (mdc_1 !== null && mdc_1 !== undefined) {
      if (Object.keys(mdc_1).length === 0) {
        isValid = false;
        errors['mdc_1'] = 'Please Select MDC'
      } else {
        errors['mdc_1'] = '';

        subjects_choosen.push({
          type: 'mdc_1',
          subject: mdc_1
        });
      }
    } else {
      isValid = false;
      errors['mdc_1'] = 'Please Select MDC'

    }

    if (vac !== null && vac !== undefined) {
      if (Object.entries(vac).length === 0) {
        isValid = false;

        errors["vac"] = "Please Select VAC";
      } else {
        errors["vac"] = "";

        subjects_choosen.push({
          type: 'vac',
          subject: vac
        });
      }
    } else {
      isValid = false;
      errors["mil"] = "Please Select VAC";
    }

    if (mil !== null && mil !== undefined) {
      if (Object.entries(mil).length === 0) {
        isValid = false;

        errors["mil"] = "Please Select AEC";
      } else {
        errors["mil"] = "";

        subjects_choosen.push({
          type: 'mil',
          subject: mil
        });
      }
    } else {
      isValid = false;
      errors["mil"] = "Please Select AEC";
    }


    if (Array.isArray(exam_passed) && exam_passed.length === 0) {
      isValid = false;
      errors["exam_passed"] = "Please fill exam passed.";
    } else {
      errors["exam_passed"] = "";
    }

    if (Array.isArray(last_marks) && last_marks.length < 5) {
      isValid = false;
      errors["last_marks"] = "Please fill last examination marks.";
    } else {
      errors["last_marks"] = "";
    }

    if (Array.isArray(best_subjects) && best_subjects.length < 4) {
      isValid = false;
      errors["best_subjects"] = "Please fill last examination marks.";
    } else {
      errors["best_subjects"] = "";
    }

    if (Array.isArray(subjects_choosen) && subjects_choosen.length === 0) {
      isValid = false;
      errors["subjects_choosen"] = "Please select subjects.";
    } else {
      errors["subjects_choosen"] = "";
    }


    if (has_gap === null || has_gap === '') {
      isValid = false;
      errors["has_gap"] = "Please select this field";
    } else {
      errors["has_gap"] = "";
    }

    if (has_gap === "YES") {
      if (gap_admission === null || gap_admission === '') {
        isValid = false;
        errors["gap_admission"] = "Please fill gap admission";
      } else {
        errors["gap_admission"] = "";
      }

      if (gap_admission === "YES") {

        if (gap_course === null || gap_course === '') {
          isValid = false;
          errors["gap_course"] = "Please fill gap course";
        } else {
          errors["gap_course"] = "";
        }

        if (gap_institute === null || gap_institute === '') {
          isValid = false;
          errors["gap_institute"] = "Please fill gap institute";
        } else {
          errors["gap_institute"] = "";
        }

        if (gap_reason === null || gap_reason === '') {
          isValid = false;
          errors["gap_reason"] = "Please fill gap reason";
        } else {
          errors["gap_reason"] = "";
        }

        if (gap_roll_no === null || gap_roll_no === '') {
          isValid = false;
          errors["gap_roll_no"] = "Please fill gap roll no";
        } else {
          errors["gap_roll_no"] = "";
        }

      }
      else {
        errors["gap_course"] = "";
        errors["gap_institute"] = "";
        errors["gap_reason"] = "";
        errors["gap_roll_no"] = "";
      }

    }
    else {
      errors["gap_admission"] = "";
      errors["gap_course"] = "";
      errors["gap_institute"] = "";
      errors["gap_reason"] = "";
      errors["gap_roll_no"] = "";
    }


    //console.log(errors);
    if (!isValid) {
      Modal.error({
        title: 'Error Message',
        content: <ul>
          {Object.values(errors)?.map((el, idx) => el !== '' && <li key={idx}>{el}</li>)}
        </ul>
      })
    }

    this.setState({
      errors,
      subjects_choosen
    });

    return { isValid, subjects_choosen };
  };

  onSubmit = (e) => {
    e.preventDefault();
    //console.log(this.state)
    let data = this.handleValidation();
    //console.log("🚀 ~ file: EducationalFormBA.js:625 ~ EducationalFormBA ~ data:", data)
    if (data.isValid) {
      let d = {
        email: this.state.email,
        course: this.state.course,
        course_type: this.state.course_type,
        unique_id: this.state.unique_id,
        subjects_choosen: data.subjects_choosen,
        total_marks: this.state.total_marks,
        marks_obtained: this.state.marks_obtained,
        percentage: this.state.percentage,
        exam_passed: this.state.exam_passed,
        best_subjects: this.state.best_subjects,
        last_marks: this.state.last_marks,
        has_gap: this.state.has_gap,
        gap_admission: this.state.gap_admission,
        gap_course: this.state.gap_course,
        gap_institute: this.state.gap_institute,
        gap_reason: this.state.gap_reason,
        gap_roll_no: this.state.gap_roll_no,
        step: 2
      };
      //console.log(d)

      this.props.setData(d);
    }
  };

  showData(value) {
    if (Array.isArray(value) && value.length > 0) {
      let new_arr = value.map((el, index) => el.label);

      return new_arr.join(",");
    } else {
      return "";
    }
  }

  sentTotalData = (data) => {
    //console.log(data)
    this.setState({
      last_marks: data.last_marks,
      // best_subjects: data.best_subjects,
      total_marks: data.over_all,
      marks_obtained: data.obtained,
      percentage: data.percentage,
    });
  };




  showMePapers = (subject) => {
    //to show papers associated to the subject
    //console.log(subject)

    return null
    if (subject !== null && subject !== undefined) {
      if (Object.keys(subject).length > 0) {
        return (
          <div>
            <AlertDiv back={orange[100]} border={orange[400]}>
              <div style={{ fontSize: 13 }}>Available Papers</div>

              <ul>
                {Array.isArray(subject.papers) &&
                  subject.papers?.map((el, index) =>
                    el.semester == 1 ? (
                      <li style={{ fontSize: 12 }} key={index}>
                        {el.label}
                      </li>
                    ) : null
                  )}
              </ul>
            </AlertDiv>
          </div>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }

    return null;
  };



  checkOption = (sub_code, type) => {

    let major_l_1 = this.state.major_1_m_1;
    let major_l_2 = this.state.major_1_m_2;
    let major_l_3 = this.state.major_1_m_3;
    let major_l_4 = this.state.major_1_m_4;
    let major_l_5 = this.state.major_1_m_5;

    // only one of the above is selected
    let direct_major_1 = null;

    if (major_l_1 != null && major_l_1 != undefined) {
      direct_major_1 = major_l_1
    }

    if (major_l_2 != null && major_l_2 != undefined) {
      direct_major_1 = major_l_2
    }

    if (major_l_3 != null && major_l_3 != undefined) {
      direct_major_1 = major_l_3
    }

    if (major_l_4 != null && major_l_4 != undefined) {
      direct_major_1 = major_l_4
    }

    if (major_l_5 != null && major_l_5 != undefined) {
      direct_major_1 = major_l_5
    }






return false;
    // apply settings
    if (direct_major_1?.sub_code == "PHY-C-FYUGP") {
      // for core 2 
      if (type == "core2" && sub_code != "MATH-C-FYUGP") {
        return true
      }

      if (type == "core3" && !["CHM-C-FYUGP", "STS-C-FYUGP", "CS-C-FYUGP", "GEO-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }


    if (direct_major_1?.sub_code == "CHM-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["PHY-C-FYUGP", "STS-C-FYUGP", "CS-C-FYUGP", "GEO-C-FYUGP", "MATH-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["PHY-C-FYUGP", "STS-C-FYUGP", "CS-C-FYUGP", "GEO-C-FYUGP", "MATH-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }


    if (direct_major_1?.sub_code == "MATH-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "STS-C-FYUGP", "CS-C-FYUGP", "GEO-C-FYUGP", "ECO-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "STS-C-FYUGP", "CS-C-FYUGP", "GEO-C-FYUGP", "ECO-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }


    if (direct_major_1?.sub_code == "STS-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "MATH-C-FYUGP", "CS-C-FYUGP", "ECO-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "MATH-C-FYUGP", "CS-C-FYUGP", "ECO-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }



    if (direct_major_1?.sub_code == "ANTH-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["CHM-C-FYUGP", "BOT-C-FYUGP", "ZOO-C-FYUGP", "GEO-C-FYUGP", "GGY-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["CHM-C-FYUGP", "BOT-C-FYUGP", "ZOO-C-FYUGP", "GEO-C-FYUGP", "GGY-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }


    if (direct_major_1?.sub_code == "BOT-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["CHM-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["PHY-C-FYUGP", "CS-C-FYUGP", "ANTH-C-FYUGP", "ZOO-C-FYUGP", "GGY-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }

    if (direct_major_1?.sub_code == "ZOO-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["CHM-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["PHY-C-FYUGP", "CS-C-FYUGP", "ANTH-C-FYUGP", "BOT-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }

    if (direct_major_1?.sub_code == "GEO-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "MATH-C-FYUGP", "CS-C-FYUGP", "ANTH-C-FYUGP", "STS-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "MATH-C-FYUGP", "CS-C-FYUGP", "ANTH-C-FYUGP", "STS-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }


    if (direct_major_1?.sub_code == "GGY-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "MATH-C-FYUGP", "CS-C-FYUGP", "ANTH-C-FYUGP", "STS-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "MATH-C-FYUGP", "CS-C-FYUGP", "STS-C-FYUGP", "ECO-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }


    if (direct_major_1?.sub_code == "CS-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "MATH-C-FYUGP", "STS-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["PHY-C-FYUGP", "CHM-C-FYUGP", "MATH-C-FYUGP", "STS-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }


    if (direct_major_1?.sub_code == "ECO-C-FYUGP") {
      // for core 2 
      if (type == "core2" && !["GGY-C-FYUGP", "MATH-C-FYUGP", "STS-C-FYUGP"].includes(sub_code)) {
        return true
      }

      if (type == "core3" && !["GGY-C-FYUGP", "MATH-C-FYUGP", "STS-C-FYUGP"].includes(sub_code)) {
        return true
      }
    }



    return false;






  }


  render() {
    let { classes } = this.props;


    return (
      <div>
        <form onSubmit={this.onSubmit}>
          <Typography variant="h5">Educational Details</Typography>
          <Typography>
            All <span className="red-alert">*</span> marked fields are mandatory
          </Typography>

          <br />
          {/* <Card raised style={{ borderLeft: "solid 5px #1715DA" }}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} lg={6} md={6}>
                <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                    Unique ID (Generate from DHE Portal.Click the below link.){" "}
                    <a
                      style={{ color: "blue" }}
                      target="__blank"
                      href={`https://dheonlineadmission.amtron.in/sp/`}
                    >
                      https://dheonlineadmission.amtron.in/sp/
                    </a>{" "}
                    <span className="red-alert">*</span>
                  </Typography>

                  <input
                    className="form-control"
                    type="text"
                    required
                    name="unique_id"
                    value={this.state.unique_id}
                    onChange={this.onChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <br /> */}
          <Card raised style={{ borderLeft: "solid 5px #1715DA" }}>
            <CardContent>
              <div>
                <AlertDiv back={orange[100]} border={orange[400]}>
                  <Typography variant="subtitle2">
                    <Grade style={{ fontSize: 10 }} /> Important points to be
                    noted before you choose the subjects:
                  </Typography>

                  <ul>
                    <li>
                      <Typography>
                        Fill up the subjects according to your preferance
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ color: "red" }} variant="body2">
                        If Botany is choosen, you must Choose Chemistry from Group I as one core subject.
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ color: "red" }} variant="body2">
                        For any confusion please refer prospectus.
                      </Typography>
                    </li>

                    <li>
                      <Typography style={{ color: "red" }} variant="body2">
                        The skill enhancement subject will be allotted during the time of admission.
                      </Typography>
                    </li>

                  </ul>


                  <Button target="_blank" href="/pdfs/FYUGP-Science_v1.pdf" variant="contained" color="primary">Course Structure of Science Stream under Four-Year Under-Graduate Programme (FYUGP) </Button>
                </AlertDiv>
              </div>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} lg={12} md={12}>
                  <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                    Combination of subjects Sought for ({this.state.course} -{" "}
                    {this.state.course_type}) 1st Semester{" "}
                    <span className="red-alert">*</span>
                  </Typography>
                </Grid>

                {this.state.course_type === "HONOURS" && (
                  <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Paper style={{ border: `solid 1px ${blue[700]}` }}>
                      <CardHeader title={`MAJOR (CORE I)`} />
                      <Divider />
                      <div style={{ padding: "10px" }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} lg={12} md={12}>
                            {this.state.errors["major_1"] !== "" ? (
                              <div>
                                <Typography
                                  variant="caption"
                                  style={{ color: "red" }}
                                >
                                  {this.state.errors["major_1"]}
                                </Typography>
                              </div>
                            ) : null}

                            <Typography variant="subtitle2">
                              Group I : Physical Science {" "}

                            </Typography>
                            <Sel
                              options={this.state.f_major_list_1.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core1')
                                })
                              })}
                              value={this.state.major_1_m_1}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "major_1_m_1")}

                            />
                            <br />
                            <Typography variant="subtitle2">
                              Group II : Biological Science & Anthropology {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_2.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core1')
                                })
                              })}
                              value={this.state.major_1_m_2}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "major_1_m_2")}

                            />

                            <br />
                            <Typography variant="subtitle2">
                              Group III : Earth & Environmental Science {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_3.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core1')
                                })
                              })}
                              value={this.state.major_1_m_3}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "major_1_m_3")}

                            />

                            <br />
                            <Typography variant="subtitle2">
                              Group IV : Computer & Information Science {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_4.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core1')
                                })
                              })}
                              value={this.state.major_1_m_4}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "major_1_m_4")}

                            />
                            <br />
                            <Typography variant="subtitle2">
                              Group V : Social Science for Arts Group {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_5.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core1')
                                })
                              })}
                              value={this.state.major_1_m_5}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "major_1_m_5")}

                            />

                          </Grid>

                        </Grid>
                      </div>
                    </Paper>
                  </Grid>
                )}

                {this.state.course_type === "HONOURS" && (
                  <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Paper style={{ border: `solid 1px ${blue[700]}` }}>
                      <CardHeader title={`MINOR (CORE II)`} />
                      <Divider />
                      <div style={{ padding: "10px" }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} lg={12} md={12}>
                            {this.state.errors["generic_1_1"] !== "" ? (
                              <div>
                                <Typography
                                  variant="caption"
                                  style={{ color: "red" }}
                                >
                                  {this.state.errors["generic_1_1"]}
                                </Typography>
                              </div>
                            ) : null}

                            <Typography variant="subtitle2">
                              Group I : Physical Science {" "}

                            </Typography>
                            <Sel
                              options={this.state.f_major_list_1.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core2')
                                })
                              })}
                              value={this.state.generic_1_m_1}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_1_m_1")}

                            />
                            <br />
                            <Typography variant="subtitle2">
                              Group II : Biological Science & Anthropology {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_2.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core2')
                                })
                              })}
                              value={this.state.generic_1_m_2}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_1_m_2")}

                            />

                            <br />
                            <Typography variant="subtitle2">
                              Group III : Earth & Environmental Science {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_3.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core2')
                                })
                              })}
                              value={this.state.generic_1_m_3}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_1_m_3")}

                            />

                            <br />
                            <Typography variant="subtitle2">
                              Group IV : Computer & Information Science {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_4.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core2')
                                })
                              })}
                              value={this.state.generic_1_m_4}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_1_m_4")}

                            />

                            <br />
                            <Typography variant="subtitle2">
                              Group V : Social Science for Arts Group {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_5.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core2')
                                })
                              })}
                              value={this.state.generic_1_m_5}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_1_m_5")}

                            />

                          </Grid>

                        </Grid>
                      </div>
                    </Paper>
                  </Grid>
                )}

                {this.state.course_type === "HONOURS" && (
                  <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Paper style={{ border: `solid 1px ${blue[700]}` }}>
                      <CardHeader title={`MINOR (CORE III)`} />
                      <Divider />
                      <div style={{ padding: "10px" }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} lg={12} md={12}>
                            {this.state.errors["generic_1_2"] !== "" ? (
                              <div>
                                <Typography
                                  variant="caption"
                                  style={{ color: "red" }}
                                >
                                  {this.state.errors["generic_1_2"]}
                                </Typography>
                              </div>
                            ) : null}

                            <Typography variant="subtitle2">
                              Group I : Physical Science {" "}

                            </Typography>
                            <Sel
                              options={this.state.f_major_list_1.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core3')
                                })
                              })}
                              value={this.state.generic_2_m_1}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_2_m_1")}

                            />
                            <br />
                            <Typography variant="subtitle2">
                              Group II : Biological Science & Anthropology {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_2.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core3')
                                })
                              })}
                              value={this.state.generic_2_m_2}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_2_m_2")}

                            />

                            <br />
                            <Typography variant="subtitle2">
                              Group III : Earth & Environmental Science {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_3.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core3')
                                })
                              })}
                              value={this.state.generic_2_m_3}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_2_m_3")}

                            />

                            <br />
                            <Typography variant="subtitle2">
                              Group IV : Computer & Information Science {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_4.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core3')
                                })
                              })}
                              value={this.state.generic_2_m_4}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_2_m_4")}

                            />
                            <br />
                            <Typography variant="subtitle2">
                              Group V : Social Science for Arts Group {" "}
                            </Typography>
                            <Sel
                              options={this.state.f_major_list_5.map((el) => {
                                return ({
                                  ...el,
                                  isDisabled: this.checkOption(el.sub_code, 'core3')
                                })
                              })}
                              value={this.state.generic_2_m_5}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "generic_2_m_5")}

                            />


                          </Grid>

                        </Grid>
                      </div>
                    </Paper>
                  </Grid>
                )}

                {this.state.course_type === "HONOURS" && (
                  <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Paper style={{ border: `solid 1px ${green[700]}` }}>
                      <CardHeader title={`Multi-disciplinary Course`} />
                      <Divider />
                      <div style={{ padding: "10px" }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} lg={12} md={12}>
                            {this.state.errors["mdc_1"] !== "" ? (
                              <div>
                                <Typography
                                  variant="caption"
                                  style={{ color: "red" }}
                                >
                                  {this.state.errors["mdc_1"]}
                                </Typography>
                              </div>
                            ) : null}


                            <Sel
                              options={this.state.mdc_list_1}
                              value={this.state.mdc_1_m_1}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "mdc_1_m_1")}

                            />
                            <br />
                            {/* <Typography variant="subtitle2">
                              Group II : Mathematical Science {" "}
                            </Typography>
                            <Sel
                              options={this.state.mdc_list_2}
                              value={this.state.mdc_1_m_2}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "mdc_1_m_2")}

                            />

                            <br />
                            <Typography variant="subtitle2">
                              Group III : Computer Application {" "}
                            </Typography>
                            <Sel
                              options={this.state.mdc_list_3}
                              value={this.state.mdc_1_m_3}
                              isLoading={!this.state.isLoaded}
                              isClearable={true}
                              isSearchable={true}
                              onChange={this.onSubChange.bind(this, "mdc_1_m_3")}

                            /> */}

                          </Grid>

                        </Grid>
                      </div>
                    </Paper>
                  </Grid>
                )}

                <Grid item xs={12} sm={12} lg={4} md={4}>
                  <Paper style={{ border: `solid 1px ${orange[700]}` }}>
                    <CardHeader
                      title={`Value Added Course`}

                    />
                    <Divider />
                    <div style={{ padding: "10px" }}>
                      <Grid container spacing={24}>
                        <Grid item xs={12} sm={12} lg={12} md={12}>
                          {this.state.errors["vac"] !== "" ? (
                            <div>
                              <Typography
                                variant="caption"
                                style={{ color: "red" }}
                              >
                                {this.state.errors["vac"]}
                              </Typography>
                            </div>
                          ) : null}

                          <Typography variant="subtitle2">
                            VAC {" "}
                            <span className="red-alert">*</span>
                          </Typography>
                          <Sel
                            // options={this.state.vac_list}
                            value={this.state.vac}
                            isLoading={!this.state.isLoaded}
                            isClearable={false}
                            isSearchable={false}
                            onChange={this.onSubChange.bind(this, "vac")}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Paper>
                </Grid>

                <Grid item xs={12} sm={12} lg={4} md={4}>
                  <Paper style={{ border: `solid 1px ${orange[700]}` }}>
                    <CardHeader
                      title={`Ability Enhancement Course`}

                    />
                    <Divider />
                    <div style={{ padding: "10px" }}>
                      <Grid container spacing={24}>
                        <Grid item xs={12} sm={12} lg={12} md={12}>
                          {this.state.errors["mil"] !== "" ? (
                            <div>
                              <Typography
                                variant="caption"
                                style={{ color: "red" }}
                              >
                                {this.state.errors["mil"]}
                              </Typography>
                            </div>
                          ) : null}

                          <Typography variant="subtitle2">
                            AEC {" "}
                            <span className="red-alert">*</span>
                          </Typography>
                          <Sel
                            options={this.state.aec_list}
                            value={this.state.mil}
                            isLoading={!this.state.isLoaded}
                            isClearable={false}
                            isSearchable={false}
                            onChange={this.onSubChange.bind(this, "mil")}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Paper>
                </Grid>
              </Grid>

              <br />
              <br />

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} lg={12} md={12}>
                  <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                    H.S/12th Std. Examination Details{" "}
                    <span className="red-alert">*</span>
                  </Typography>

                  {this.state.errors["exam_passed"] !== "" ? (
                    <div>
                      <Typography variant="caption" style={{ color: "red" }}>
                        {this.state.errors["exam_passed"]}
                      </Typography>
                    </div>
                  ) : null}

                  <PreviousExamination
                    onNewChange={this.onNewChange.bind(this, "exam_passed")}
                    data={this.state.exam_passed}
                  />
                  <div>
                    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                      Unique ID (Generate from DHE Portal.Click the below link.){" "}
                      <a
                        style={{ color: "blue" }}
                        target="__blank"
                        href={`https://dheonlineadmission.amtron.in/sp/`}
                      >
                        https://dheonlineadmission.amtron.in/sp/
                      </a>{" "}
                      {Array.isArray(this.state.exam_passed) && this.state.exam_passed.length > 0 && this.state.exam_passed[0].board == "AHSEC" && <span className="red-alert">*</span>}
                    </Typography>

                    <input
                      className="form-control"
                      type="text"
                      required={Array.isArray(this.state.exam_passed) && this.state.exam_passed.length > 0 && this.state.exam_passed[0].board == "AHSEC"}
                      name="unique_id"
                      value={this.state.unique_id}
                      onChange={this.onChange}
                    />
                  </div>
                </Grid>


                <Grid item xs={12} sm={12} lg={12} md={12}>
                  {this.state.errors["best_subjects"] !== "" ? (
                    <div>
                      <Typography variant="caption" style={{ color: "red" }}>
                        {this.state.errors["best_subjects"]}
                      </Typography>
                    </div>
                  ) : null}
                  <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                    Best of 4 (including ENGLISH)
                    <span className="red-alert">*</span>
                  </Typography>
                  <AlertDiv back={orange[100]} border={orange[400]}>


                    <ul>
                      <li>
                        <Typography>
                          You must exclude marks of any vocational including physical education.
                        </Typography>
                      </li>
                      <li>
                        <Typography>
                          You need to incluse marks of English here
                        </Typography>
                      </li>
                      <li>
                        <Typography>
                          Put only science subjects e.g. Physics, Chemistry, Mathematics
                        </Typography>
                      </li>

                    </ul>
                  </AlertDiv>

                  <BestOfThree
                    onNewChange={this.onNewChange.bind(this, 'best_subjects')}
                    type={0}
                    rows={4}
                    sentTotalData={this.sentTotalData.bind(this)}
                    data={this.state.best_subjects}
                  />


                </Grid>


                <Grid item xs={12} sm={12} lg={12} md={12}>
                  {this.state.errors["last_marks"] !== "" ? (
                    <div>
                      <Typography variant="caption" style={{ color: "red" }}>
                        {this.state.errors["last_marks"]}
                      </Typography>
                    </div>
                  ) : null}
                  <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                    Marks Obtained in last examination passed{" "}
                    <span className="red-alert">*</span>
                  </Typography>

                  <LastMarks

                    sentTotalData={this.sentTotalData.bind(this)}

                    last_marks={this.state.last_marks}

                  />

                  {/* <BestOfThree
                    onNewChange={this.onNewChange.bind(this, 'last_marks')}
                    type={1}
                    rows={5}
                    sentTotalData={this.sentTotalData.bind(this)}
                    data={this.state.last_marks}
                  /> */}


                </Grid>


                <Grid item xs={12} sm={12} lg={3} md={3}>
                  <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                    Do you have any gap ? <span className="red-alert">*</span>
                  </Typography>
                  <select
                    className="form-control"
                    type="text"
                    name="has_gap"
                    required
                    value={this.state.has_gap}
                    onChange={this.onChange}
                  >
                    <option value="">Select</option>
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </Grid>

                {this.state.has_gap === "YES" && (
                  <React.Fragment>
                    <Grid item xs={12} sm={12} lg={3} md={3}>
                      <Typography
                        variant="subtitle2"
                        style={{ fontWeight: 700 }}
                      >
                        Have you taken admission in any institute/college ?{" "}
                        <span className="red-alert">*</span>
                      </Typography>
                      <select
                        className="form-control"
                        type="text"
                        name="gap_admission"
                        required
                        value={this.state.gap_admission}
                        onChange={this.onChange}
                      >
                        <option value="">Select</option>
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                    </Grid>

                    {this.state.gap_admission === "YES" && (
                      <React.Fragment>
                        <Grid item xs={12} sm={12} lg={3} md={3}>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 700 }}
                          >
                            Name of the course{" "}
                            <span className="red-alert">*</span>
                          </Typography>
                          <input
                            className="form-control"
                            type="text"
                            name="gap_course"
                            value={this.state.gap_course}
                            onChange={this.onChange}
                            required
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} lg={3} md={3}>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 700 }}
                          >
                            Name of the Institute{" "}
                            <span className="red-alert">*</span>
                          </Typography>
                          <input
                            className="form-control"
                            type="text"
                            name="gap_institute"
                            value={this.state.gap_institute}
                            onChange={this.onChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} lg={3} md={3}>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 700 }}
                          >
                            Enrollment No/Registration No{" "}
                            <span className="red-alert">*</span>
                          </Typography>
                          <input
                            className="form-control"
                            type="text"
                            name="gap_roll_no"
                            value={this.state.gap_roll_no}
                            onChange={this.onChange}
                            required
                          />
                        </Grid>
                      </React.Fragment>
                    )}

                    <Grid item xs={12} sm={12} lg={3} md={3}>
                      <Typography
                        variant="subtitle2"
                        style={{ fontWeight: 700 }}
                      >
                        Reason of Gap <span className="red-alert">*</span>
                      </Typography>
                      <textarea
                        className="form-control"
                        type="text"
                        name="gap_reason"
                        value={this.state.gap_reason}
                        onChange={this.onChange}
                        required
                      ></textarea>
                    </Grid>

                    <Grid item xs={12} sm={12} lg={12} md={12}>
                      <AlertDiv back={orange[100]} border={orange[400]}>
                        <strong>Warning !!</strong>

                        <Typography>
                          In case, if any false information detected about the
                          gap period, the application/admission will be
                          rejected.
                        </Typography>
                      </AlertDiv>
                    </Grid>
                  </React.Fragment>
                )}
              </Grid>




            </CardContent>

            <CardActions className={classes.cardActions}>
              <Button variant="contained" type="button" onClick={this.props.back}>
                Previous
              </Button>&nbsp;
              <Button
                variant="contained"
                className={classes.buttonSubmit}
                type="submit"
              >
                Save &amp; Proceed to next step
              </Button>
            </CardActions>
          </Card>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(EducationalFormBSC);
